import { createSlice } from "@reduxjs/toolkit"
import type { IPermission } from "../../types/permission"

const initialState: { permissions: IPermission[] } = {
  permissions: [],
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setPermissions: (state) => {
      state.permissions = [...state.permissions]
    },
  },
 })

export const { setPermissions } = authSlice.actions

export default authSlice.reducer
